export const TARIFS_SPA = [
  { key: 'nb_sde_40', label: 'SDE 40€', prix: 40 },
  { key: 'nb_sde_35', label: 'SDE 35€', prix: 35 },
  { key: 'nb_sde_33', label: 'SDE 33€', prix: 33 },
  { key: 'nb_sde_30', label: 'SDE 30€', prix: 30 },
  { key: 'nb_sde_29', label: 'SDE 29€', prix: 29 },
  { key: 'nb_sde_20', label: 'SDE 20€', prix: 20 },
]

export const TARIFS_HYDRO = [
  { key: 'nb_hydro_60', label: 'Hydro 60€', prix: 60 },
  { key: 'nb_hydro_55', label: 'Hydro 55€', prix: 55 },
  { key: 'nb_hydro_35', label: 'Hydro 35€', prix: 35 },
  { key: 'nb_hydro_33', label: 'Hydro 33€', prix: 33 },
  { key: 'nb_hydro_30', label: 'Hydro 30€', prix: 30 },
  { key: 'nb_hydro_29', label: 'Hydro 29€', prix: 29 },
]

export const TAUX_TVA = 1.20
export const TAUX_REMUNERATION = 0.3520
export const SEUIL_MINIMUM = 185.00
export const TAUX_REUNION = 25.00 // € par heure de réunion mensuelle

export function calculerSeance(data, tarifsPole, seuil = SEUIL_MINIMUM) {
  const tarifs = tarifsPole === 'SPA' ? TARIFS_SPA : TARIFS_HYDRO
  const vipKey = tarifsPole === 'SPA' ? 'nb_vip_gratuit' : 'nb_hydro_vip'

  let ca_ttc = 0
  let total_payant = 0

  for (const t of tarifs) {
    const nb = parseInt(data[t.key] || 0)
    ca_ttc += nb * t.prix
    total_payant += nb
  }

  const nb_vip = parseInt(data[vipKey] || 0)
  const nb_sup = parseInt(data.nb_sup || 0)
  const nb_eleves = parseInt(data.nb_eleves || 0)

  const ca_ht = parseFloat((ca_ttc / TAUX_TVA).toFixed(2))
  const remuneration_reelle = parseFloat((ca_ht * TAUX_REMUNERATION).toFixed(2))
  const remuneration_affichee = Math.round(Math.max(remuneration_reelle, seuil))

  return {
    ca_ttc,
    ca_ht,
    total_massage_payant: total_payant,
    total_massage_gratuit: nb_vip,
    total_massage: total_payant + nb_vip,
    nb_sup,
    nb_eleves,
    remuneration_reelle,
    remuneration_affichee,
  }
}

export function formatEuro(val) {
  if (val === null || val === undefined) return '—'
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(val)
}

export function formatDate(dateStr) {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const MOIS_LABELS = [
  '', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
]
